import React from 'react';
import './commentsSection.scss';

type Props = {
    value: Record<string, string>;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
};

export const CommentsSection: React.FC<Props> = ({ value, onChange }) => {
    return (
        <section className="commentsSection" aria-label="Комментарии">
            <div className="commentsSection__field">
                <textarea
                    id="orderComment"
                    className="commentsSection__textarea"
                    name="orderComment"
                    rows={5}
                    maxLength={300}
                    value={value.orderComment || ''}
                    onChange={onChange}
                    placeholder="Комментарии к заказу"
                />
            </div>
        </section>
    );
};
